import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "./../src/actions";
import "font-awesome/css/font-awesome.min.css";
import "./scss/style.css";
import { DefaultLayout, PortalLayout } from "./containers";
import { Login, Page404, Register, MemberLogin } from "./views/Pages";
import Messenger from "./components/FacebookMessenger/Messenger";

class App extends Component {
  componentDidMount() {
    this.props.fetchUser();
  }

  render() {
    const auth = this.props.auth || {};

    return (
      <div>
        {/* Brain of rounter */}
        <BrowserRouter>
          <>
            <Switch>
              <>
                <Route path="/home/data-enquiry" exact component={PortalLayout} />
                {/* Public routes */}
                {!auth.isAuth && (
                  <>
                    <Route path="/admin" exact component={Login} />
                    <Route path="/memberLogin" exact component={MemberLogin} />
                    <Route path="/register" exact component={Register} />
                    <Route
                      path={[
                        "/",
                        "/home",
                        "/home/productDetail/:id",
                        "/home/viewCart",
                        "/home/confirmPage",
                        "/home/purchaseSuccess",
                        "/home/contact",
                        "/home/faq",
                        "/home/list",
                        "/home/joytel-detail/:orderTid",
                        "/home/roam-detail/:orderNum",
                        "/home/renew-detail/:orderNum"
                      ]}
                      exact
                      component={PortalLayout}
                    />
                  </>
                )}

                {/* Authenticated routes */}
                {auth.isAuth && (
                  <>
                    {/* Admin route */}
                    {auth.roleId != 3 && (
                      <Route path="/" component={DefaultLayout} />
                    )}

                    {/* User route */}
                    {auth.roleId === 3 && (
                      <Route path={["/home", "/user/changepassword"]} component={PortalLayout} />
                    )}

                    {/* Wrong role fallback */}
                    <Route exact path="/404" component={Page404} />
                    {/* <Redirect to={auth.roleId === 3 ? "/home" : "/report/dashboard"} /> */}
                  </>
                )}
              </>
            </Switch>
            {/* Show messenger only on client side */}
            {auth.isAuth && auth.roleId === 3 && (
              <Messenger
                pageId="522472770958294"
                themeColor="#0084ff"
                loggedInGreeting="Hi! Welcome to Sea Farer Internet Service. How can we help you?"
                loggedOutGreeting="Hi! Need help with eSIM? Chat with us!"
                greetingDialogDisplay="show"
              />
            )}
          </>
        </BrowserRouter>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { auth: state.auth };
}

export default connect(mapStateToProps, actions)(App);